<script>
import api from "@services/api";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import AgendaRegra from "./forms/AgendaRegra";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    FullCalendar,
    AgendaRegra,
    Treeselect
  },
  data: function() {
    return {
      selectedConsultor: undefined,
      selectedClientes: undefined,
      agendaTitulo: "",
      consultorList: [],
      clienteList: [],
      selectedFiltro: undefined,
      agendaIdSelected: null,
      selectedAgendaRegraId: null,
      showModalDelete: false,
      showAgendaRegra: false,
      selectedMes: false,
      selectedSemana: true,
      copyEvent: false,
      selectedObject: {},
      calendarOptions: {
        plugins: [
          bootstrapPlugin,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        headerToolbar: false,
        initialView: "timeGridWeek",
        editable: this.$store.state.auth.user.perfil === "Administrador",
        selectable: this.$store.state.auth.user.perfil === "Administrador",
        selectMirror: true,
        allDaySlot: false,
        dayMaxEvents: true,
        weekends: true,
        businessHours: {
          daysOfWeek: [1, 2, 3, 4, 5],
          startTime: "08:00",
          endTime: "18:00"
        },
        selectConstraint: {
          startTime: "00:00",
          endTime: "24:00"
        },
        eventConstraint: {
          start: moment().format("YYYY-MM-DD hh:mm"),
          end: "2100-01-01"
        },
        displayEventTime: true,
        displayEventEnd: true,
        scrollTime: "06:00:00",
        firstDay: 0,
        eventTextColor: "#FFFFFF",
        themeSystem: "bootstrap",
        locale: ptBrLocale,
        eventDisplay: "block",
        events: this.handleEvents,
        eventDrop: this.handleEventDrop,
        eventResize: this.handleEventResize,
        select: this.handleSelect
      }
    };
  },
  watch: {
    selectedConsultor: {
      deep: true,
      handler() {
        this.$refs.calendar.getApi().refetchEvents();
      }
    },
    selectedClientes: {
      deep: true,
      handler() {
        this.$refs.calendar.getApi().refetchEvents();
      }
    }
  },
  mounted() {
    this.atualizaAgendaTitulo();
    if (this.$store.state.auth.user.perfil === "Administrador") {
      this.getConsultorList();
      this.getClienteList();
    }
  },
  methods: {
    updateEvent(id, expediente) {
      if (!expediente) {
        this.agendaIdSelected = id;
        this.showModalAgendaRegra();
      }
    },
    showModalDeleteEvent(id) {
      this.showModalDelete = true;
      this.selectedAgendaRegraId = id;
    },
    closeModalDeleteEvent() {
      this.showModalDelete = false;
      this.selectedAgendaRegraId = null;
    },
    showModalAgendaRegra() {
      if (this.selectedSemana) {
        this.$helper.openModal();
        this.showAgendaRegra = true;
      }
    },
    closeModalAgendaRegra() {
      this.$helper.closeModal();
      this.showAgendaRegra = false;
      this.$refs.calendar.getApi().refetchEvents();
      this.agendaIdSelected = null;
      this.selectedObject = {};
    },
    downloadAgenda() {
      api
        .get(`api/Atendimento/DownloadAgenda`, {
          params: {
            dataInicial: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.start,
            dataFinal: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.end
          }
        })
        .then(response => {
          this.$helper.callDownload(response.data["data"]);
        });
    },
    excluirAgenda() {
      api
        .delete(`crud/AgendaRegra/${this.selectedAgendaRegraId}`)
        .then(response => {
          if (response) {
            this.closeModalDeleteEvent();
            this.$refs.calendar.getApi().refetchEvents();
          }
        })
        .catch(this.closeModalDeleteEvent());
    },
    atualizaAgendaTitulo() {
      if (this.$refs.calendar) {
        this.agendaTitulo = this.$refs.calendar.getApi().currentData.viewTitle;
      } else {
        this.agendaTitulo = "";
      }
    },
    prevCalendar() {
      this.$refs.calendar.getApi().prev();
      this.atualizaAgendaTitulo();
    },
    nextCalendar() {
      this.$refs.calendar.getApi().next();
      this.atualizaAgendaTitulo();
    },
    monthCalendar() {
      this.$refs.calendar.getApi().changeView("dayGridMonth");
      this.atualizaAgendaTitulo();
      this.selectedMes = true;
      this.selectedSemana = false;
    },
    weekCalendar() {
      this.$refs.calendar.getApi().changeView("timeGridWeek");
      this.atualizaAgendaTitulo();
      this.selectedMes = false;
      this.selectedSemana = true;
    },
    handleEvents(param, callback) {
      var ClientesId = null;
      var consultoresId = null;
      if (this.selectedConsultor) {
        consultoresId = this.lodash.join(this.selectedConsultor, ",");
      }

      if (this.selectedClientes) {        
        ClientesId = this.lodash.join(this.selectedClientes, ",");
      }

      api
        .get(`api/Atendimento/Agenda`, {
          params: {
            dataInicial: param.start,
            dataFinal: param.end,
            consultoresId: consultoresId,
            ClientesId: ClientesId
          }
        })
        .then(response => {
          var events = [];
          if (response.data["data"]) {
            response.data["data"].forEach(e => {
              events.push({
                id: e.id,
                title: e.titulo,
                start: e.dataInicio,
                end: e.dataFim,
                backgroundColor: e.hexaCor,
                extendedProps: {
                  description: e.descricao,
                  agendaId: e.agendaId,
                  temRegra: e.agendaRegraId ? true : false,
                  expediente: e.expedienteId ? true : false
                },
                borderColor: "#DDD",
                textColor: "#333"
              });
            });
          }
          this.getClienteList();
          this.getConsultorList();
          callback(events);
        });
    },
    handleSelect(selectInfo) {
      let calendarApi = selectInfo.view.calendar;
      calendarApi.unselect();

      if (selectInfo) {
        this.selectedObject.data = moment(selectInfo.start).format(
          "YYYY-MM-DD"
        );
        this.selectedObject.horaInicio = moment(selectInfo.start).format(
          "HH:mm:ss"
        );
        this.selectedObject.horaFim = moment(selectInfo.end).format("HH:mm:ss");
      }

      this.showModalAgendaRegra();
    },
    async handleEventDrop(selectInfo) {
      if (selectInfo.event.extendedProps.expediente) {
        selectInfo.revert();
        return;
      }
      var conf = false;
      var eventDate = moment(selectInfo.event.start).format("YYYY-MM-DD");
      var oldEventDate = moment(selectInfo.oldEvent.start).format("YYYY-MM-DD");
      var actions;

      if (
        (selectInfo.event.extendedProps.temRegra &&
          eventDate == oldEventDate) ||
        !selectInfo.event.extendedProps.temRegra
      ) {
        actions = {
          copiar: "Copiar Agendamento",
          mover: "Mover Agendamento",
          CANCELAR: "Cancelar"
        };
      } else {
        actions = { copiar: "Copiar Agendamento", CANCELAR: "Cancelar" };
      }

      conf = await this.$dialog.confirm({
        text: "Confirme a ação desejada.",
        actions: actions,
        position: "middle"
      });
      if (conf == "copiar") {
        this.copyEventCalendar(selectInfo);
      } else if (conf == "mover") {
        this.moveEvent(selectInfo);
      } else {
        selectInfo.revert();
      }
    },
    async handleEventResize(selectInfo) {
      var conf = await this.$dialog.confirm({
        text: "Deseja alterar o agendamento?",
        actions: { true: "Sim", false: "Não" }
      });
      if (conf) {
        this.moveEvent(selectInfo);
      } else {
        selectInfo.revert();
      }
    },
    getObjectPropertySelectInfo(selectInfo) {
      let horaInicioAgendamento = moment(selectInfo.event.start).format(
        "HH:mm"
      );
      let horaFimAgendamento = moment(selectInfo.event.end).format("HH:mm");
      let dataAgendamento = moment(selectInfo.event.start).format("YYYY-MM-DD");
      let agendaId = selectInfo.event._def.extendedProps.agendaId;
      var objPost = {
        id: agendaId,
        Data: dataAgendamento,
        HoraInicio: horaInicioAgendamento,
        HoraFim: horaFimAgendamento
      };
      return objPost;
    },
    copyEventCalendar(selectInfo) {
      var objPost = this.getObjectPropertySelectInfo(selectInfo);
      api
        .post(`crud/AgendaRegra/CopyAgenda`, objPost)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.$refs.calendar.getApi().refetchEvents();
          } else {
            selectInfo.revert();
          }
        })
        .catch(selectInfo.revert());
    },
    moveEvent(selectInfo) {
      var objPost = this.getObjectPropertySelectInfo(selectInfo);
      api
        .post(`crud/AgendaRegra/DropAgenda`, objPost)
        .then(response => {
          if (response.data && response.data.status == "SUCCESS") {
            this.$refs.calendar.getApi().refetchEvents();
          } else {
            selectInfo.revert();
          }
        })
        .catch(selectInfo.revert());
    },
    getConsultorList() {
      this.selectedFiltro = undefined;
      api
        .get(`Crud/Consultor/Consultores`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC",
            dataInicial: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.start,
            dataFinal: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.end   
          }
        })
        .then(response => {
          this.consultorList = response.data["data"];          
        });
    },
    getClienteList() {
      api.get(`crud/Expediente/clientesPorData`,{
         params: {           
            dataInicial: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.start,
            dataFinal: this.$refs.calendar.getApi().currentData.dateProfile
              .currentRange.end
            }
      }).then(response => {
        this.clienteList = response.data["data"];
      });      
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    ListClienteComp: function() {
      return this.clienteList.map(c => ({ label: c.nome, id: c.id }));;
    },
    ListConsultorComp: function() {      
      return this.consultorList.map(c => ({ label: c.nome, id: c.id }));
    }
  }
};
</script>

<template>
  <div class="container mb-3">
    <b-row class="mb-3" v-if="user.perfil === 'Administrador'">
      <treeselect
        :options="ListClienteComp"
        :multiple="true"
        :flatten-search-results="true"
        :disable-branch-nodes="true"
        placeholder="Clientes"
        v-model="selectedClientes"
        class="col-md-4"
      />
      <treeselect
        :options="ListConsultorComp"
        v-model="selectedConsultor"
        placeholder="Consultores"
        :multiple="true"
        class="col-md-4"
      />
    </b-row>
    <b-row>
      <b-col>
        <b-button-group>
          <b-button
            class="btn btn-icon mb-3"
            variant="primary"
            v-on:click="prevCalendar()"
          >
            <i class="fe-chevron-left" />
          </b-button>

          <b-button
            class="btn btn-icon mb-3"
            variant="primary"
            v-on:click="nextCalendar()"
          >
            <i class="fe-chevron-right" />
          </b-button>
        </b-button-group>

        <b-button
          class="btn btn-icon mb-3 ml-2"
          variant="primary"
          v-on:click="downloadAgenda()"
        >
          <i class="fe-download" />
        </b-button>

        <b-button
          class="btn btn-icon mb-3 ml-2"
          variant="primary"
          v-if="user.perfil === 'Administrador'"
          v-on:click="showModalAgendaRegra()"
        >
          <i class="fe-calendar" />
        </b-button>
      </b-col>
      <b-col class="text-center">
        <h3>{{ this.agendaTitulo }}</h3>
      </b-col>
      <b-col class="text-right">
        <b-button-group>
          <b-button
            class="btn btn-icon mb-3"
            variant="primary"
            :pressed="selectedMes"
            v-on:click="monthCalendar()"
            >Mês
          </b-button>
          <b-button
            class="btn btn-icon mb-3"
            variant="primary"
            :pressed="selectedSemana"
            v-on:click="weekCalendar()"
            >Semana
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <FullCalendar
      :options="calendarOptions"
      disableResizing:true
      :selectable="true"
      ref="calendar"
    >
      <template v-slot:eventContent="arg">
        <div
          v-b-tooltip.hover
          :title="
            `${arg.timeText} (${arg.event.extendedProps.description})
          ${arg.event.title}`
          "
          custom-class="fc-event-main"
        >
          <div class="" v-if="user.perfil === 'Administrador'">
            <i
              class="fe-x float-right"
              v-if="arg.event.extendedProps.agendaId"
              @click="showModalDeleteEvent(arg.event.extendedProps.agendaId)"
            />
          </div>
          <div
            class="text-left calendar-text"
            v-if="user.perfil === 'Administrador'"
            @click="
              updateEvent(
                arg.event.extendedProps.agendaId,
                arg.event.extendedProps.expediente
              )
            "
          >
            <b
              >{{ arg.timeText }}
              <i
                class="fe-repeat float-right"
                v-if="arg.event.extendedProps.temRegra"
              />
            </b>
            {{ arg.event.title }}
          </div>

          <div
            class="text-left calendar-text"
            v-if="user.perfil !== 'Administrador'"
          >
            <b
              >{{ arg.timeText }}
              <i
                class="fe-repeat float-right"
                v-if="arg.event.extendedProps.temRegra"
              />
            </b>
            {{ arg.event.title }}
          </div>
        </div>
      </template>
    </FullCalendar>

    <b-modal
      id="agendaRegraModal"
      v-model="showAgendaRegra"
      size="lg"
      centered
      hide-footer
      title="Regra de agenda"
      @close="closeModalAgendaRegra"
    >
      <AgendaRegra
        :agendaId="agendaIdSelected"
        :closeModalAgendaRegra="closeModalAgendaRegra"
        :select="selectedObject"
      />
    </b-modal>

    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="closeModalDeleteEvent()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="excluirAgenda()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="closeModalDeleteEvent()"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
